






































































import { Component, Mixins } from "vue-property-decorator";
import MultiProfessionListUserFilter from "../../../filters/wizard/guest/MultiProfessionListUserFilter.vue";
import DepartmentListUserFilter from "../../../filters/wizard/guest/DepartmentListUserFilter.vue";
import UserListSelector from "../../../selectors/UserListSelector.vue";
import UserDetailViewer from "../../../viewers/UserDetailViewer.vue";
import { UserListSelectorDialogMixin } from "../../mixins";

@Component({
  components: {
    MultiProfessionListUserFilter,
    DepartmentListUserFilter,
    UserListSelector,
    UserDetailViewer,
  },
})
export default class UserListSelectorDialog extends Mixins(UserListSelectorDialogMixin) {
  $refs!: {
    userSelector: UserListSelector;
  };

  async openedDialog(): Promise<void> {
    await this.$nextTick();
    if (this.isDepartmentFeatureEnable) {// 起動時に科で職員の初回絞り込みが行われる.診療科非表示時は全職員を表示し選択できるようにする
      this.$refs.userSelector.scrollIntoView();
    }
  }}
